import flatten from './flatten'

const deepErrorsCheck = (key, value) => {
  return typeof value === 'object' && typeof value.ref === 'undefined'
}

export default (obj) => flatten(obj, deepErrorsCheck)
